import { Card, Grid } from '@mui/material';
import React from 'react';
import { DatagridLoading, RecordContextProvider, useListContext } from 'react-admin';

const CardDatagrid = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data, isLoading } = useListContext();

  if (isLoading) return <DatagridLoading nbChildren={3} />;

  return (
    <Grid container spacing={4}>
      {data?.map((record, index) => (
        <Grid
          key={record.id || index}
          size={{
            xs: 12,
            lg: 6,
          }}
        >
          <Card variant="outlined" sx={{ margin: 0, height: '100%' }}>
            <RecordContextProvider value={record}>
              {children}
            </RecordContextProvider>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default CardDatagrid;
